module.exports = __webpack_public_path__ + "static/service17-8672bab9650446b427e93344c459cb59.jpg";